import type { FldLenderDecision } from './fullLenderDecisionTypes';

export type CreditDecision = {
    approvalStatus: string;
    approvedAmount: number;
    approvedRate: number;
    approvedTerm: number;
    buyRate: number;
    decisionShown?: boolean;
    financeMethod: string;
    isActive?: boolean;
    lenderId: string;
    lenderLogo: string;
    lenderName: string;
    monthlyPayment: number;
};

export type CreditDecisionState = {
    decisionsList: CreditDecision[];
    sourcePartnerId: string;
    selectedDecision: CreditDecision | object;
    fullLenderDecisions?: {
        lenderDecisions?: FldLenderDecision[];
        financeMethod?: string;
        isLoadingLenderDecisions?: boolean;
    };
};

export type LenderListProps = {
    lenderDecisions: CreditDecision[];
    sortOrder: any[];
    showFooter?: () => void;
};

export enum DealerDecisionStatus {
    APP_SUBMITTED = 'App Submitted',
    APPROVED = 'Approved',
    CONDITIONALLY_APPROVED = 'ConditionallyApproved',
    COUNTER_OFFER = 'CounterOffer',
    PENDING = 'Pending',
    DECLINED = 'Declined',
    NOT_SUBMITTED = 'AppNotSubmitted'
}
